import { BASE_URL } from 'config/constants';


export const restAPIs = {

  getAbout: (language) => ({
    method: 'get',
    endpoint: `${BASE_URL}/json_page.php?pageId=16&language=${language}`
  }),
  getPortfolio: (language, page) => ({
    method: 'get',
    endpoint: `${BASE_URL}/json_artgallery.php?artistId=471&language=${language}&page=${page}`
  }),

  contact: (body) => ({
    method: 'post',
    body,
    endpoint: `${BASE_URL}/contact.php`
  }),





};